import React from 'react';
export function AIProcessTimeline() {
  // Define the AI process steps
  const steps = [{
    number: '01',
    title: 'RECOPILACIÓN DE DATOS',
    description: 'Captura continua de datos del mercado energético, precios históricos y patrones de demanda en tiempo real.'
  }, {
    number: '02',
    title: 'ANÁLISIS DE PATRONES',
    description: 'Algoritmos de machine learning identifican correlaciones y anomalías en las fluctuaciones de precios energéticos.'
  }, {
    number: '03',
    title: 'PROYECCIÓN DE PRECIOS',
    description: 'Modelos predictivos generan pronósticos de alta precisión sobre movimientos futuros del mercado spot.'
  }, {
    number: '04',
    title: 'OPTIMIZACIÓN DE ESTRATEGIAS',
    description: 'Cálculo de momentos óptimos para compra/venta de energía maximizando ingresos.'
  }, {
    number: '05',
    title: 'IMPLEMENTACIÓN Y MONITOREO',
    description: 'Ejecución automatizada de estrategias con ajustes continuos basados en resultados y nuevos datos.'
  }];
  return <div className="relative p-8 bg-white corner-accent mb-16" data-id="element-74">
      <div className="mb-8" data-id="element-75">
        <div className="text-xs uppercase tracking-wider mb-2 text-gray-600" data-id="element-76">
          METODOLOGÍA
        </div>
        <h2 className="text-2xl font-bold mb-4" data-id="element-77">
          PROCESO DE OPTIMIZACIÓN DE IA
        </h2>
        <p className="text-sm text-gray-700 max-w-3xl" data-id="element-78">
          Nuestro sistema de inteligencia artificial sigue un proceso riguroso
          de cinco etapas para transformar datos energéticos complejos en
          decisiones operativas precisas que maximizan los ingresos y la
          eficiencia operacional de los activos.
        </p>
      </div>
      {/* Mobile view - vertical steps */}
      <div className="md:hidden space-y-6" data-id="element-79">
        {steps.map((step, index) => <div key={index} className="relative p-4 border border-gray-200" data-id="element-80">
            <div className="text-xl font-bold mb-1" data-id="element-81">{step.number}</div>
            <div className="text-sm font-bold mb-2" data-id="element-82">{step.title}</div>
            <p className="text-xs text-gray-700" data-id="element-83">{step.description}</p>
          </div>)}
      </div>
      {/* Desktop view - horizontal timeline */}
      <div className="hidden md:block" data-id="element-84">
        <div className="relative" data-id="element-85">
          {/* Horizontal line */}
          <div className="absolute top-8 left-0 right-0 h-0.5 bg-black" data-id="element-86"></div>
          {/* Steps */}
          <div className="grid grid-cols-5 gap-4" data-id="element-87">
            {steps.map((step, index) => <div key={index} className="relative pt-14" data-id="element-88">
                {/* Number circle */}
                <div className="absolute top-4 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-8 h-8 bg-white border border-black flex items-center justify-center" data-id="element-89">
                  <span className="text-sm font-bold" data-id="element-90">{step.number}</span>
                </div>
                {/* Content */}
                <div className="relative p-4 border border-gray-200 h-full" data-id="element-91">
                  <div className="text-sm font-bold mb-2" data-id="element-92">{step.title}</div>
                  <p className="text-xs text-gray-700" data-id="element-93">{step.description}</p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </div>;
}